var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNextonIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.419 1.258 44.434 45.27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M 33.856 12.635 L 33.856 13.777 C 25.761 13.777 23.502 23.574 23.502 42.282 L 23.502 45.581 L 42.772 11.665 C 43.658 10.133 43.95 8.623 43.647 7.174 C 43.502 6.494 43.25 5.885 42.895 5.363 C 42.589 4.741 42.188 4.219 41.671 3.753 C 40.569 2.765 39.113 2.263 37.344 2.263 L 1.763 2.263 C 1.821 5.657 2.573 8.295 3.995 10.108 C 5.476 11.995 7.561 12.635 10.373 12.635 L 33.856 12.635 Z",
    fill: "#337BFF",
    style: {},
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextonIcon);
export default __webpack_public_path__ + "static/media/nexton-icon.24005384b1e69af2bdf57f1047cb1f9c.svg";
export { ForwardRef as ReactComponent };